/* ⚛ REACT */
import { useMemo } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button } from "../../../../Components";

/* 📁 ASSETS */
import { Back, ArrowLeft, ArrowRight } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { CalendarContainer, BackIcon } from "./styles";

const CalendarMonth = ({ container, selectedDate, onDateChange }) => {
  const { t } = useTranslation();

  // ✅ Meses vindos do i18next
  const months = t(
    "dashboards.sub-items.loss-control.months",
    { returnObjects: true }
  );

  // ✅ Data base (sempre válida)
  const date = useMemo(() => {
    return selectedDate instanceof Date ? selectedDate : new Date();
  }, [selectedDate]);

  const selectedMonth = date.getMonth();
  const year = date.getFullYear();

  // 🔧 Função única para atualizar data
  const updateDate = (month, year) => {
    const newDate = new Date(date);
    newDate.setMonth(month);
    newDate.setFullYear(year);
    onDateChange?.(newDate);
  };

  const handleSelectMonth = (index) => {
    updateDate(index, year);
  };

  const handlePrevYear = () => {
    updateDate(selectedMonth, year - 1);
  };

  const handleNextYear = () => {
    updateDate(selectedMonth, year + 1);
  };

  const handleBackToday = () => {
    onDateChange?.(new Date());
  };

  return (
    <CalendarContainer $container={container}>
      <div className="header">
        <button className="arrow" onClick={handlePrevYear}>
          <BackIcon src={ArrowLeft} />
        </button>

        <span className="year-label">{year}</span>

        <button className="arrow" onClick={handleNextYear}>
          <BackIcon src={ArrowRight} />
        </button>
      </div>

      <div className="content-selected-month">
        <div className="calendar-grid">
          {months.map((month, index) => (
            <div
              key={index}
              className={`month-cell ${
                selectedMonth === index ? "selected-month" : ""
              }`}
              onClick={() => handleSelectMonth(index)}
            >
              {month}
            </div>
          ))}
        </div>

        <div className="button-wrapper">
          <Button
            text={t("buttons.return")}
            color='green-blue'
            icon={<BackIcon src={Back}/>}
            onClick={handleBackToday}
          />
        </div>
      </div>
    </CalendarContainer>
  );
};

export default CalendarMonth;
